import { normalizeError } from 'core/common/errors';
import { OrganicChannelAttributionStrategy } from 'core/common/services';
import { AppThunk } from 'core/common/store';
import { checkIsClientSide } from 'core/common/utils/checkIsClientSide';
import { isOrganicChannel } from 'core/common/utils/isOrganicChannel';
import { getUtmSource } from 'core/user/store';
import { userUtmTagsUpdated } from './userUtmTagsUpdated';

export const markUtmSourceForIncomingUser =
  (): AppThunk => async (dispatch, getState, services) => {
    const { utmTagsService, loggingService, channelAttributionService } = services;

    // Reads document.referrer — createStore dispatches this on the server too, where it would throw.
    if (!checkIsClientSide()) return;

    const utmSource = getUtmSource(getState());

    if (utmSource) return;

    try {
      const referrer = document.referrer;
      const isOrganicUser = isOrganicChannel(referrer);

      if (isOrganicUser) {
        channelAttributionService.setAttributionStrategy(
          new OrganicChannelAttributionStrategy(referrer),
        );
      }

      const utmTags = channelAttributionService.getUtmTags();

      const updatedUtmTags = utmTagsService.updateUtmTags(utmTags, 'session');

      dispatch(userUtmTagsUpdated(updatedUtmTags));
    } catch (err) {
      const error = normalizeError(err);

      loggingService.error(error);
    }
  };
